<template>
  <div class="dashboard pad-to-15">
    <general-top-bar :title="$t('reports.dashboardReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <!-- Left Column -->
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
            <option value="" :label="$t('general.all')">{{$t('general.all')}}</option>
              <option v-for="loc in locations" :key="loc.id" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="posUsers.length">
            <label class="form-label text-start w-100">{{$t('reports.operator')}}</label>
            <select class="form-control mar-bt-15" v-model="selectedPosUser">
              <option value="" selected :label="$t('general.alls')">{{$t('general.alls')}}</option>
              <option v-for="operator in posUsers" :key="operator.id" :label="operator.firstname + ' ' + operator.lastname" :value="operator.id">
                {{operator.firstname}} {{operator.lastname}}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left"
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
          <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
          </div>
          <!-- <div class="search-button-reports form-group pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
          </div> -->
        </p>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;"> {{ $t('reports.interval')}}: <b>{{orders.valid[0]}} {{valid_from}}</b> - <b>{{orders.valid[1]}} {{valid_to}}</b></p>
      </div>

      <!--Stats cards - Row 1-->
      <div class="row pad-to-15 pad-bt-5 all-cards dashboard-resize-statistics-card stats-cards-row">
        <div v-for="(stats, key) in firstRowCards" :key="key" :class="[cardsClass, 'card-' + key, 'stats-card-wrapper']">
          <stats-card>
            <div class="icon-big text-center"  slot="header">
              <img :src="`/static/img/icons/${stats.icon}`">
            </div>
            <div class="numbers" slot="content">
              <p>{{stats.title}}</p>
              <span>{{stats.value !== undefined && stats.value !== null ? stats.value : ''}}</span>
              <small v-if="stats.canceled">( {{stats.canceled}} {{$t('ordersStatus.CANCELED')}})</small>
              <p v-if="stats.average">{{ stats.average }}</p>
            </div>
          </stats-card>
        </div>
      </div>

      <!--Stats cards - Row 2-->
      <div class="row pad-to-5 pad-bt-15 all-cards dashboard-resize-statistics-card stats-cards-row">
        <div v-for="(stats, key) in secondRowCards" :key="key" :class="[cardsClass, 'card-' + key, 'stats-card-wrapper']">
          <stats-card>
            <div class="icon-big text-center"  slot="header">
              <img :src="`/static/img/icons/${stats.icon}`">
            </div>
            <div class="numbers" slot="content">
              <p>{{stats.title}}</p>
              <span>{{stats.value !== undefined && stats.value !== null ? stats.value : ''}}</span>
              <small v-if="stats.canceled">( {{stats.canceled}} {{$t('ordersStatus.CANCELED')}})</small>
              <p v-if="stats.average">{{ stats.average }}</p>
            </div>
          </stats-card>
        </div>
      </div>

      <!--Charts Row 1: Orders Chart and Sales Chart-->
      <div class="row text-left">
        <!-- Orders Chart -->
        <div class="col-md-12">
          <chart-card :chart-data="ordersChart.data" :chart-options="ordersChart.options" ref="refOrdersChart">
            <div slot="header">
              <h4 class="card-title">{{$t('dashboard.orderChart')}}</h4>
              <p class="category" v-if="orders.valid && orders.valid.length === 2">
                <img src="/static/img/icons/icon-calendar.png"> {{orders.valid[0]}} - {{orders.valid[1]}}
              </p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i> {{$t('dashboard.completed')}}
              </div>
            </div>
          </chart-card>
        </div>
        <!-- Sales chart -->
        <div class="col-md-12">
          <chart-card :chart-data="salesChart.data" :chart-options="salesChart.options" ref="salesChart">
            <div slot="header">
              <h4 class="card-title">{{$t('dashboard.salesChart')}}</h4>
              <p class="category" v-if="orders.valid && orders.valid.length === 2">
                <img src="/static/img/icons/icon-calendar.png"> {{orders.valid[0]}} - {{orders.valid[1]}}
              </p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i> {{$t('dashboard.salesIn')}} {{currency}}
              </div>
            </div>
          </chart-card>
        </div>
      </div>

      <!--Charts Row 2: Payment Methods Chart-->
      <div class="row text-left">
        <div class="col-md-12">
          <chart-bars-card
            v-loading="loading"
            :chart-data="paymentMethodSales.data"
            :chart-options="paymentMethodSales.options"
            ref="paymentMethodSales"
          >
            <template v-if="!hasPaymentMethodData && !loading">
              <div class="no-data-message" style="text-align: center; margin: 20px;">
                <h3>{{ $t('reports.noDataAvailable') }}</h3>
              </div>
            </template>
            <div slot="header">
              <h4 class="card-title">{{$t('reports.paymentTypes')}}</h4>
              <p class="category" v-if="orders.valid && orders.valid.length === 2">
                <img src="/static/img/icons/icon-calendar.png"> {{orders.valid[0]}} - {{orders.valid[1]}}
              </p>
            </div>
            <div slot="footer">
              <div class="chart-legend" style="display: flex; flex-wrap: wrap;">
                <div
                  v-for="(label, index) in paymentMethodSales.data.labels"
                  :key="index"
                  style="display: flex; align-items: center; margin-right: 12px;"
                >
                  <i
                    class="fa fa-circle"
                    :style="{ color: colors[index % colors.length], marginRight: '5px' }"
                  ></i>
                  <span>{{ label }} - {{ formatMoneyAmount(paymentMethodSales.data.series[0][index] || 0) }}</span>
                </div>
              </div>
            </div>
          </chart-bars-card>
        </div>
      </div>
      <!--Charts Row 3: Top Products and Delivery Chart-->
      <div class="row text-left charts-row-equal-height">
        <div class="col-md-6 chart-bar-label">
          <chart-bars-card :chart-data="topProdsChart.data" :chart-options="topProdsChart.options" ref="topProdsChart">
            <template v-if="!hasTopProdsData && !loading">
              <div class="no-data-message" style="text-align: center; margin: 20px;">
                <h3>{{ $t('reports.noDataAvailable') }}</h3>
              </div>
            </template>
            <div slot="header">
              <h4 class="card-title">{{$t('dashboard.top5Chart')}}</h4>
              <p class="category" v-if="orders.valid && orders.valid.length === 2">
                <img src="/static/img/icons/icon-calendar.png"> {{orders.valid[0]}} - {{orders.valid[1]}}
              </p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i> {{$t('reports.salesProductNr')}}
              </div>
            </div>
          </chart-bars-card>
        </div>
        <div class="col-md-6 delivery-chart-container">
          <chart-bars-card :chart-data="deliveryChart.data" :chart-options="deliveryChart.options" ref="deliveryChart">
            <template v-if="!hasDeliveryData && !loading">
              <div class="no-data-message" style="text-align: center; margin: 20px;">
                <h3>{{ $t('reports.noDataAvailable') }}</h3>
              </div>
            </template>
            <div slot="header">
              <h4 class="card-title">{{$t('dashboard.orderingChart')}}</h4>
              <p class="category" v-if="orders.valid && orders.valid.length === 2">
                <img src="/static/img/icons/icon-calendar.png"> {{orders.valid[0]}} - {{orders.valid[1]}}
              </p>
            </div>
            <div slot="footer">
              <div class="chart-legend">
                <i class="fa fa-circle text-info"></i> {{$t('dashboard.nrOfOrders')}}
              </div>
            </div>
          </chart-bars-card>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, DatePicker, TimeSelect} from 'element-ui'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
  import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(DatePicker)
  Vue.use(TimeSelect)

  export default {
    components: {
      GeneralTopBar,
      StatsCard,
      ChartCard,
      CircleChartCard,
      ChartPieCard,
      ChartBarsCard
    },
    props: {
      isDashboardReport: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      firstRowCards () {
        return {
          'new_orders': this.statsCards.new_orders,
          'total_orders': this.statsCards.total_orders,
          'revenue': this.statsCards.revenue,
          'installed_apps': this.statsCards.installed_apps
        }
      },
      secondRowCards () {
        return {
          'orders_with_discount': this.statsCards.orders_with_discount,
          'total_discount': this.statsCards.total_discount,
          'orders_with_fidelity': this.statsCards.orders_with_fidelity,
          'total_fidelity_discount': this.statsCards.total_fidelity_discount
        }
      },
      hasPaymentMethodData () {
        return this.paymentMethodSales.data.labels.length > 0 &&
               this.paymentMethodSales.data.series.length > 0 &&
               this.paymentMethodSales.data.series[0] &&
               this.paymentMethodSales.data.series[0].some(val => val > 0)
      },
      hasTopProdsData () {
        return this.topProdsChart.data.labels.length > 0 &&
               this.topProdsChart.data.series.length > 0 &&
               this.topProdsChart.data.series[0] &&
               this.topProdsChart.data.series[0].some(val => val > 0)
      },
      hasDeliveryData () {
        return this.deliveryChart.data.labels.length > 0 &&
               this.deliveryChart.data.series.length > 0 &&
               this.deliveryChart.data.series[0] &&
               this.deliveryChart.data.series[0].some(val => val > 0)
      }
    },
    watch: {
      isDashboardReport () {
        // if (this.isDashboardReport) {
        this.initializeData()
        this.verifyUserLocations()
        this.getPosUsers()
        this.getData()
        // }
      },
      hasPaymentMethodData () {
        return this.paymentMethodSales.data.labels.length > 0 &&
               this.paymentMethodSales.data.series.length > 0 &&
               this.paymentMethodSales.data.series[0] &&
               this.paymentMethodSales.data.series[0].some(val => val > 0)
      },
      hasTopProdsData () {
        return this.topProdsChart.data.labels.length > 0 &&
               this.topProdsChart.data.series.length > 0 &&
               this.topProdsChart.data.series[0] &&
               this.topProdsChart.data.series[0].some(val => val > 0)
      },
      hasDeliveryData () {
        return this.deliveryChart.data.labels.length > 0 &&
               this.deliveryChart.data.series.length > 0 &&
               this.deliveryChart.data.series[0] &&
               this.deliveryChart.data.series[0].some(val => val > 0)
      }
    },
    data () {
      return {
        currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
        locations: [],
        showLocations: false,
        posUsers: [],
        selectedPosUser: '',
        cardsClass: 'col-lg-3 col-sm-12',
        valid_from: '00:00',
        valid_to: '23:59',
        loading: false,
        orders: {
          'valid': [
            moment().date(1).format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ],
          location: '',
          method: '',
          search: ''
        },
        pickerNames: ['date_from', 'date_to'],
        pickerOptions: {
          disabledDate (date) {
            return date < moment().subtract(12, 'months').startOf('day')
          }
        },
        statsCards: {
          'new_orders': {
            type: 'warning',
            icon: 'dash1.png',
            title: this.$t('dashboard.tile1Title'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'total_orders': {
            type: 'success',
            icon: 'dash2.png',
            title: this.$t('dashboard.tile2Title'),
            value: '',
            canceled: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'revenue': {
            type: 'danger',
            icon: 'dash3.png',
            title: this.$t('dashboard.tile3Title'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'installed_apps': {
            type: 'info',
            icon: 'dash2.png',
            title: this.$t('dashboard.tile4Title'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'orders_with_discount': {
            type: 'warning',
            icon: 'dash1.png',
            title: this.$t('reports.ordersWithDiscount'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'total_discount': {
            type: 'success',
            icon: 'dash2.png',
            title: this.$t('reports.totalDiscount'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'orders_with_fidelity': {
            type: 'danger',
            icon: 'dash3.png',
            title: this.$t('reports.ordersWithFidelity'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'total_fidelity_discount': {
            type: 'info',
            icon: 'dash2.png',
            title: this.$t('reports.totalFidelityDiscount'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          }
        },
        ordersChart: {
          data: {
            labels: [],
            series: [],
            canceled: [],
            delivered: []
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            },
            height: '200px'
          }
        },
        salesChart: {
          data: {
            labels: ['9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'],
            series: []
          },
          options: {
            showArea: true,
            height: '200px',
            axisX: {
              showGrid: false
            },
            showLine: true
          }
        },
        topProdsChart: {
          title: 'Today',
          data: {
            labels: ['Cappucinno', 'Ristretto', 'Expresso', 'Ice coffe', 'Cookie'],
            series: [
              [411, 345, 201, 189, 157]
            ]
          },
          options: {
            seriesBarDistance: 10,
            showArea: true,
            height: '245px',
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            }
          }
        },
        deliveryChart: {
          title: 'Today',
          data: {
            labels: ['Pick-up', 'Meet me half-way', 'On Location', 'Delivery'],
            series: [
              [411, 345, 201, 189]
            ]
          },
          options: {
            seriesBarDistance: 10,
            showArea: true,
            height: '245px',
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            }
          }
        },
        paymentMethodSales: {
          title: '',
          data: {
            labels: [],
            series: []
          },
          options: {
            seriesBarDistance: 20,
            showArea: true,
            height: '500px',
            axisX: {
              scaleMinSpace: 50,
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            }
          }
        },
        colors: [
          '#f44336', // red
          '#2196f3', // blue
          '#ff9800', // orange
          '#9c27b0', // purple
          '#00bcd4', // cyan
          '#8bc34a', // light green
          '#ffc107', // amber
          '#3f51b5', // indigo
          '#ff5722', // deep orange
          '#795548', // brown
          '#607d8b', // blue grey
          '#009688', // teal
          '#cddc39', // lime
          '#673ab7', // deep purple
          '#03a9f4', // light blue
          '#aed581', // soft green
          '#ffb74d', // soft orange
          '#ba68c8'  // soft purple
        ]
      }
    },
    methods: {
      verifyUserLocations () {
        this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
          id: location.true_id,
          name: location.name
        }))

        if (!this.isOwner()) {
          let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

          if (allowedLocations.length === 0) {
            this.showLocations = true
            this.locations.forEach((element) => {
              allowedLocations.push(element.id)
            })
          }

          this.locations = this.locations.filter(function (el) {
            return allowedLocations.includes(el.id)
          })
        }

        if (this.locations.length > 1) {
          this.showLocations = true
        }

        let filterCookie = this.$cookie.get('filter-locations')
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          this.orders.location = filterCookie[0]
        } else {
          this.orders.location = ''
        }
      },
      getPosUsers () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/pos/all/users', 'GET', data, (response) => {
          if (response.status) {
            this.posUsers = response.data.pos_user
          }
        })
      },
      initializeData () {
        // This method can be removed or kept for backward compatibility
      },
      changeValidFrom () {
        if (this.valid_to === '24:00') {
          this.valid_to = '23:59'
        }
        if (this.valid_from === '24:00') {
          this.valid_from = '23:59'
        }
        if (!this.valid_from) {
          this.valid_from = '00:00'
        }
        if (!this.valid_to) {
          this.valid_to = '23:59'
        }
      },
      updateData () {
        this.getData()
        this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
      },
      getData () {
        if (!this.isDashboardReport) {
          return
        }
        if (this.valid_to === '24:00') {
          this.valid_to = '23:59'
        }
        if (this.valid_from === '24:00') {
          this.valid_from = '23:59'
        }

        let fromDate = this.orders.valid[0] + ' ' + this.valid_from
        let toDate = this.orders.valid[1] + ' ' + this.valid_to

        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          from_date: fromDate,
          to_date: toDate
        }

        if (this.orders.location && this.orders.location !== '') {
          data.location_id = this.orders.location
          this.cardsClass = 'col-lg-3 col-sm-12'
        } else {
          this.cardsClass = 'col-lg-3 col-sm-12'
        }

        if (this.selectedPosUser && this.selectedPosUser !== '') {
          data.operator_id = this.selectedPosUser
        }

        this.loading = true

        this.apiRequest('/reports/v2/dashboard-report', 'GET', data, function (response) {
          if (response.status === true) {
            self.ordersChart.data.labels = response.data.orders.labels
            self.ordersChart.data.series = [response.data.orders.delivered]
            self.$refs.refOrdersChart.initChart()

            self.salesChart.data.labels = response.data.sales.labels
            self.salesChart.data.series = [response.data.sales.values]
            self.$refs.salesChart.initChart()

            self.topProdsChart.data.labels = response.data.top_products.labels
            self.topProdsChart.data.series = [response.data.top_products.values]
            self.$nextTick(() => {
              if (self.$refs.topProdsChart) {
                self.$refs.topProdsChart.initChart()
              }
            })

            self.deliveryChart.data.labels = response.data.delivery_types.labels
            self.deliveryChart.data.series = [response.data.delivery_types.values]
            self.$nextTick(() => {
              if (self.$refs.deliveryChart) {
                self.$refs.deliveryChart.initChart()
              }
            })

            // Payment Methods Chart - Request chart data exactly as in SalesPaymentMethod.vue
            self.apiRequest('/reports/v2/sales-payment-type', 'GET', data, function (pmResponse) {
              if (pmResponse.status === true && pmResponse.data) {
                if (pmResponse.data.payment_types && pmResponse.data.payment_types.length) {
                  self.$nextTick(() => {
                    self.paymentMethodSales.options.chartPadding = {
                      top: 30,
                      right: 10,
                      bottom: 20,
                      left: 20
                    }

                    if (pmResponse.data.payment_types && pmResponse.data.payment_types.length) {
                      self.paymentMethodSales.data.labels = pmResponse.data.payment_types.map(item => {
                        return self.$t('paymentTypes.' + item)
                      })
                    }

                    self.paymentMethodSales.data.series = [pmResponse.data.total_amounts]

                    // Wait for component to be ready
                    self.$nextTick(() => {
                      if (self.$refs.paymentMethodSales) {
                        self.$refs.paymentMethodSales.initChartAndReturn()

                        if (self.$refs.paymentMethodSales.chart) {
                          self.$refs.paymentMethodSales.chart.on('draw', (data) => {
                            if (data.type === 'bar') {
                              data.element.attr({
                                style: `stroke: ${self.colors[data.index % self.colors.length]}; stroke-width: 60px;`
                              })
                            }
                          })
                        }
                      }
                    })
                  })
                } else {
                  self.paymentMethodSales.data.labels = []
                  self.paymentMethodSales.data.series = [[]]
                  self.$nextTick(() => {
                    if (self.$refs.paymentMethodSales && self.$refs.paymentMethodSales.chart) {
                      self.$refs.paymentMethodSales.initChartAndReturn()
                    }
                  })
                }
              } else {
                self.paymentMethodSales.data.labels = []
                self.paymentMethodSales.data.series = [[]]
                self.$nextTick(() => {
                  if (self.$refs.paymentMethodSales && self.$refs.paymentMethodSales.chart) {
                    self.$refs.paymentMethodSales.initChartAndReturn()
                  }
                })
              }
            })

            self.statsCards.new_orders.value = response.data.counters.new_orders
            self.statsCards.total_orders.value = response.data.counters.total_orders
            self.statsCards.total_orders.canceled = response.data.counters.total_canceled
            self.statsCards.revenue.value = response.data.counters.revenue
            self.statsCards.installed_apps.value = response.data.order_average
            self.statsCards.orders_with_discount.value = response.data.orders_with_discount || 0
            var totalDiscountValue = response.data.total_discount !== undefined && response.data.total_discount !== null ? response.data.total_discount : 0
            var currencyIso = self.$session.get('selectedCompanyData')['currency_iso']
            var currencyPosition = self.getCurrencyPosition(currencyIso)
            var formattedDiscount = totalDiscountValue === 0 ? '0' : parseFloat(totalDiscountValue).toFixed(2)
            self.statsCards.total_discount.value = currencyPosition === 'left' ? currencyIso + ' ' + formattedDiscount : formattedDiscount + ' ' + currencyIso
            self.statsCards.orders_with_fidelity.value = response.data.orders_with_fidelity || 0
            var totalFidelityDiscountValue = response.data.total_fidelity_discount !== undefined && response.data.total_fidelity_discount !== null ? response.data.total_fidelity_discount : 0
            var formattedFidelityDiscount = totalFidelityDiscountValue === 0 ? '0' : parseFloat(totalFidelityDiscountValue).toFixed(2)
            self.statsCards.total_fidelity_discount.value = currencyPosition === 'left' ? currencyIso + ' ' + formattedFidelityDiscount : formattedFidelityDiscount + ' ' + currencyIso
          } else {
            swal(
              '',
              response.errors && response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
              'error'
            )
          }

          self.$nextTick(() => {
            self.loading = false
          })
        })
      },
      exportData () {
        if (this.valid_to === '24:00') {
          this.valid_to = '23:59'
        }
        if (this.valid_from === '24:00') {
          this.valid_from = '23:59'
        }

        let fromDate = this.orders.valid[0] + ' ' + this.valid_from
        let toDate = this.orders.valid[1] + ' ' + this.valid_to

        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          from_date: fromDate,
          to_date: toDate
        }

        if (this.orders.location && this.orders.location !== '') {
          data.location_id = this.orders.location
        }

        if (this.selectedPosUser && this.selectedPosUser !== '') {
          data.operator = this.selectedPosUser
        }

        this.loading = true
        this.apiRequest('/reports/dashboard-download', 'GET', data, response => {
          if (response.status === true) {
            const link = document.createElement('a')
            link.href = response.data.file
            link.setAttribute('download', response.data.file_name)
            document.body.appendChild(link)
            link.click()
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            )
          }
          this.loading = false
        })
      }
    }
  }

</script>
<style>
  .stats-cards-row {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
  }
  .stats-cards-row > div {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .stats-card-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
  }
  .stats-card-wrapper > * {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .stats-card-wrapper .card {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .stats-card-wrapper .card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* Make charts row have equal height columns */
  .charts-row-equal-height {
    display: flex;
    align-items: stretch;
  }
  .charts-row-equal-height .col-md-6 {
    display: flex;
    flex-direction: column;
  }
  .charts-row-equal-height .col-md-6 .card {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
  }
  .charts-row-equal-height .col-md-6 .card .card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  /* Fix deliveryChart y-axis labels visibility */
  .delivery-chart-container .ct-chart {
    padding-top: 20px;
    padding-left: 10px;
    overflow: visible !important;
  }

  .delivery-chart-container .ct-label.ct-vertical {
    overflow: visible !important;
  }

  .delivery-chart-container .ct-grids {
    overflow: visible !important;
  }

  .delivery-chart-container .ct-chart-bar {
    overflow: visible !important;
  }

  /* Match 2nd row colors to 1st row - same as card-new_orders, card-total_orders, card-revenue, card-installed_apps */
  .dashboard .card-orders_with_discount .card {
    background: #FEF1DC;
    border: 1px solid #FDE5BE;
  }
  .dashboard .card-orders_with_discount .card .numbers {
    color: #F39E1A;
  }
  .dashboard .card-orders_with_discount .card .numbers p {
    background-color: #FDE5BE;
    color: #F39E1A;
  }

  .dashboard .card-total_discount.stats-card-wrapper {
    height: 152px !important;
  }

  .dashboard .card-total_discount.stats-card-wrapper > * {
    height: 152px !important;
  }

  .dashboard .card-total_discount .card {
    background: #E7E3F8;
    border: 1px solid #D4CCF2;
    height: 152px !important;
    margin-bottom: 0px !important;
    min-height: 152px !important;
    max-height: 152px !important;
  }
  .dashboard .card-total_discount .card .numbers {
    color: #674BD2;
  }
  .dashboard .card-total_discount .card .numbers p {
    background-color: #D4CCF2;
    color: #674BD2;
  }

  .dashboard .card-orders_with_fidelity .card {
    background: #DDF6F3;
    border: 1px solid #C0EEE9;
  }
  .dashboard .card-orders_with_fidelity .card .numbers {
    color: #20BFAB;
  }
  .dashboard .card-orders_with_fidelity .card .numbers p {
    background-color: #C0EEE9;
    color: #20BFAB;
  }

  .dashboard .card-total_fidelity_discount .card {
    background: #E7E3F8;
    border: 1px solid #D4CCF2;
    height: 152px !important;
    margin-bottom: 0px !important;
    min-height: 152px !important;
    max-height: 152px !important;
  }
  .dashboard .card-total_fidelity_discount .card .numbers {
    color: #674BD2;
  }
  .dashboard .card-total_fidelity_discount .card .numbers p {
    background-color: #D4CCF2;
    color: #674BD2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/DashboardReport.vue